import React from "react";
import {useField, useFormikContext} from "formik";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

const getFieldCSSClasses = (touched, errors) => {
  const classes = ["form-control"];
  if (touched && errors) {
    classes.push("is-invalid");
  }

  if (touched && !errors) {
    classes.push("is-valid");
  }

  return classes.join(" ");
};


const useStyles2 = makeStyles(theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200
  }
}));

export function DateTimePickerField({ ...props }) {
  // console.log(props);
  const { setFieldValue, errors, touched } = useFormikContext();
  const {field} = props;
  // console.log(field);
  const classes2 = useStyles2();
  // console.log("datetimepicker", props)
  return (
    <>
      <TextField
                type="datetime-local"
                style={{ width: "100%" }}
                {...field}
                onChange= {evt => {
                  // console.log("date onchange", evt.target.value);
                  setFieldValue(field.name, evt.target.value)}}
                {...props}
                className={classes2.textField}
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{
                  step: "1"
                }}
              />
      {errors[field.name] && touched[field.name] ? (
        <div className="invalid-datepicker-feedback">
          {errors[field.name].toString()}
        </div>
      ) : (
        <div className="feedback">
        </div>
      )}
    </>
  );
}
